const setEnvironmentFavicon = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const faviconPath = isDevelopment ? '/favicon/dev/' : '/favicon/prod/';

  const faviconElements = document.querySelectorAll('link[rel*="icon"]');
  faviconElements.forEach((favicon) => {
    const currentPath = favicon?.getAttribute('href');
    if (currentPath.includes('/favicon/')) {
      favicon.href = currentPath?.replace('/favicon/', faviconPath);
    }
  });
};

export default setEnvironmentFavicon;
